/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Card, CardContent, Chip, IconButton, InputAdornment, makeStyles, Menu, TextField, Tooltip, Typography } from "@material-ui/core";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import { MyTable } from "../../../components/table";
import CutleryIcon from "../../../components/CurtleryIcon";
import PeopleIcon from "../../../components/PeopleIcon";
import {
	DeleteButton,
	EditButton,
} from "../../../components/ButttonsWithIcons";
import EditReservationModal from "./EditReservationModal";
import DeleteReservationModal from "./deleteReservationModal";
import { format } from "../../../heplers/format";
import {
	ChangeStatusIcon,
	CloseIcon,
	PrintIcon,
	ReportSingleIcon,
} from "../../../components/icons";
import {
	AddCircleOutline,
	DoneAll,
	EventSeat,
	PrintRounded,
	Search,
	Smartphone,
	StayCurrentPortraitRounded,
	TableChart,
	ViewModule,
} from "@material-ui/icons";
import { useReactToPrint } from "react-to-print";
import { RiCloseCircleFill } from "react-icons/ri";
import CloseServiceModal from "./closeServiceModal";
import PrintDialog from "../../../components/PrintDialog";
import { getTranslation } from "../../../heplers/translationHelper";
import ButtonWithLoading from "../../../components/ButtonWithLoading";
import { size } from "lodash";
import { Post } from "../../../actions";
import { Post_ReservationStatus_URL } from "../../../constants/apiUrls";
import { useSnackbar } from "notistack";
import { ConfirmReservationDialog } from "../../public/component/ReservationForm/confirmReservationDialog";
import { AddReservationModal } from "./addReservationModal";
import CardComponent from "../../../components/Card";

const STATUS_STYLE = {
	0: { label: () => getTranslation("Reserved", "Réservée", "Reserviert"), bg: "#FFF3E0", color: "#E65100" },
	1: { label: () => getTranslation("Confirmed", "Confirmée", "Bestätigt"), bg: "#E8F5E9", color: "#2E7D32" },
	2: { label: () => getTranslation("Done", "Terminée", "Erledigt"), bg: "#ECEFF1", color: "#546E7A" },
};

const tableNames = (row) =>
	(row.tableReserved || "")
		.split("|")
		.map((table) => table.split(",")[1])
		.filter(Boolean);

const columns = [
	{
		label: getTranslation("Title", "Title", "Title"),
		id: "title",
		component: ({ row }) => (
			<Box>
				<Typography style={{ fontWeight: 600, fontSize: 15, lineHeight: 1.2 }}>
					{row.title}
				</Typography>
				{row.phone && (
					<Typography variant="caption" style={{ color: "#607D8B" }}>
						{row.phone}
					</Typography>
				)}
			</Box>
		),
	},

	{
		label: getTranslation("Time", "Time", "Time"),
		id: "reservationTime",
		component: ({ row }) => (
			<Typography style={{ fontWeight: 700, fontSize: 15, color: "#004467" }}>
				{row.reservationTime}
			</Typography>
		),
	},

	{
		label: getTranslation("Persons", "Persons", "Persons"),
		id: "persons",
		align: "center",
		component: ({ row }) => (
			<Typography align="center" style={{ fontWeight: 700, fontSize: 15 }}>
				{row.persons}
			</Typography>
		),
	},
	{
		label: getTranslation("Kids", "Kids", "Kids"),
		id: "kids",
		align: "center",
		component: ({ row }) => (
			<Typography align="center" style={{ color: row.kids ? "#000" : "#B0BEC5" }}>
				{row.kids || "–"}
			</Typography>
		),
	},
	{
		label: getTranslation("Further info", "Further info", "Further info"),
		id: "info",
		component: ({ row }) =>
			row.allergies ? (
				<Tooltip title={row.allergies}>
					<Typography
						variant="body2"
						style={{
							maxWidth: 220,
							overflow: "hidden",
							textOverflow: "ellipsis",
							whiteSpace: "nowrap",
						}}
					>
						{row.allergies}
					</Typography>
				</Tooltip>
			) : (
				<Typography style={{ color: "#B0BEC5" }}>–</Typography>
			),
	},
	{
		label: getTranslation(
			"Reserved Tables",
			"Reserved Tables",
			"Reserved Tables"
		),
		id: "tableReserved",
		component: ({ row }) => {
			const names = tableNames(row);
			if (!names.length) return <Typography style={{ color: "#B0BEC5" }}>–</Typography>;
			return (
				<Box display="flex" flexWrap="wrap" style={{ gap: 4 }}>
					{names.map((name) => (
						<Chip
							key={name}
							label={name}
							size="small"
							style={{ fontWeight: 600, backgroundColor: "#E3F2FD", color: "#004467" }}
						/>
					))}
				</Box>
			);
		},
	},
	{
		label: getTranslation("Status", "Status", "Status"),
		id: "status",
		component: ({ row }) => {
			const style = STATUS_STYLE[row.status] || STATUS_STYLE[2];
			return (
				<Chip
					label={style.label()}
					size="small"
					style={{ fontWeight: 600, backgroundColor: style.bg, color: style.color }}
				/>
			);
		},
	},
	{
		label: getTranslation("Action", "Action", "Action"),
		id: "actions",
		align: "right",
	},
];

const ReservationTable = forwardRef( ({
	reservations,
	params,
	setParams,
	stats,
	loading,
	printData,
	refreshReservations,
},ref) => {



	const [selectedReservation, setSelectedReservation] = useState({
		persons: 0,
		reservationDate: Date.now(),
		purposeOfReservation: 0,
		timeSlotId: "",
		title: "",
		email: "",
		phone: "",
		subscribeForNews: false,
		haveSmallKids: false,
		kids: 0,
		acceptTerms: false,
		allergies: "",
	});
	const [isEdit, setIsEdit] = useState(false);
	const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
	const [showReservationForm, setShowReservationForm] = useState(false);
	const [showCloseService, setShowCloseService] = useState(false);
	const [print, setPrint] = useState(false);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
	const { enqueueSnackbar } = useSnackbar();



	const handlePageChange = (e, page) => {
		setParams({ ...params, pageNumber: page });
	};

	const confirmDelete = (data) => {
		setShowDeleteConfirm(true);
		setSelectedReservation(data);
	};

	const handleEdit = (data) => {
		setIsEdit(true);
		
			setShowReservationForm(true);
		setSelectedReservation(data);
	};

	const handleSearch = (e) => {
		setParams({ ...params, searchString: e });
	};

	const handleRowsPerPageChange = (e) => {
		setParams({ ...params, pageSize: e.target.value });
	};

	// useEffect(() => {
	// 	if (print) {
	// 		handlePrint();
	// 	}
	// }, [print]);

	const handleChangeStatus = (row) => {
		Post(
			[{ id: row?.id, status: 1 }],
			Post_ReservationStatus_URL,
			null,
			(res) => {
				enqueueSnackbar(
					res?.data
						? getTranslation(res?.data, res?.data, res?.data)
						: getTranslation(
								"Staus changed successfully",
								"Staus changed successfully",
								"Staus changed successfully"
						  ),
					{
						variant: "success",
					}
				);
				if (refreshReservations) refreshReservations();
			},
			(err) => {
				enqueueSnackbar(
					err?.data
						? err?.data
						: getTranslation(
								"Something went wrong. Please try Again",
								"Something went wrong. Please try Again",
								"Something went wrong. Please try Again"
						  ),
					{
						variant: "error",
					}
				);
			}
		);
	};

		

	// search on name, phone, email, tables and comments (done here: the list itself is not filtered by the API)
	const [search, setSearch] = useState("");
	const searchText = search.trim().toLowerCase();
	const visibleReservations = searchText
		? reservations.filter((r) =>
				[r.title, r.phone, r.email, r.allergies, tableNames(r).join(" ")]
					.filter(Boolean)
					.some((v) => String(v).toLowerCase().includes(searchText))
		  )
		: reservations;

	return (
		<>
			<Box
				display="flex"
				alignItems="center"
				flexWrap="wrap"
				style={{ gap: 12, padding: "12px 12px 4px" }}
			>
				<TextField
					size="small"
					variant="outlined"
					value={search}
					onChange={(e) => setSearch(e.target.value)}
					placeholder={getTranslation("Search", "Rechercher", "Suchen")}
					style={{ flex: "1 1 200px", maxWidth: 320 }}
					InputProps={{
						startAdornment: (
							<InputAdornment position="start">
								<Search fontSize="small" />
							</InputAdornment>
						),
					}}
				/>
				<Typography variant="body2" style={{ marginLeft: "auto", color: "#607D8B" }}>
					{visibleReservations.length} {getTranslation("Reservations", "Reservations", "Reservations")}
				</Typography>
			</Box>
		<MyTable
			auto
			compact
				loading={loading}
				// title={getTranslation("Reservations", "Reservations", "Reservations")}
				validateRow={(row)=>{
					return row.status==1
				}}
				failedRowColor="#fff6f6"
				colums={columns}
				rowsPerPage={params.pageSize}
				handleChangePage={handlePageChange}
				handleChangeRowsPerPage={handleRowsPerPageChange}
				page={params.pageNumber}
				rows={visibleReservations}
				count={visibleReservations.length}
				viewEdit
				onEdit={(row) => handleEdit(row)}
				
				actions={[
					{
						component: (row) =>
							row.status == 0 ? (
								<IconButton
									onClick={() => {
										handleChangeStatus(row);
									}}
								>
									<DoneAll />
								</IconButton>
							) : null,
					},
					{
						component: (row) => (
							<DeleteButton
								onClick={() => {
									confirmDelete(row);
								}}
							/>
						),
					},
				]}
			/>
		
			
			<EditReservationModal
				isEdit={isEdit}
				openModal={showReservationForm}
				onClose={() => {
					setSelectedReservation(null)
					setShowReservationForm(false)}}
				selectedReservation={selectedReservation}
				params={params}
				setParams={setParams}
				refreshReservations={() => refreshReservations()}
			/>
			<DeleteReservationModal
				openModal={showDeleteConfirm}
				onClose={setShowDeleteConfirm}
				selectedReservation={selectedReservation}
				params={params}
				refreshReservations={refreshReservations}
				setParams={setParams}
			/>
			<CloseServiceModal
				openDialog={showCloseService}
				handleClose={setShowCloseService}
			/>
			<div style={{ display: "none" }}>
				<PrintDialog ref={ref} params={params} rows={printData} />
			</div>
			
		</>
	);
});

export default ReservationTable;
